import { Component, OnInit, Input , ChangeDetectorRef} from '@angular/core';
import { Theme } from '../../shared/service/AutoTheme';

@Component({
    selector: 'full-layout',
    templateUrl: './full.component.html',
    styleUrls: ['./full.component.scss']
})
export class FullComponent   {

    color = 'green';
    showSettings = false;
    showMinisidebar = false; 
    showDarktheme = false;
    showHorizontalNav = true;
    showBoxedtheme = false;
    isSidebarOpen = true;
    @Input() menu : boolean;
    constructor(public theme:Theme, private cdr: ChangeDetectorRef) {}

    ngOnInit() 
    {

        this.theme.themecolor.subscribe(res=>{
            console.log("New theme is : "+res);
            this.color=res;
        });

        this.theme.showmenu.subscribe(res=>{
            console.log("Curr Menues : "+res);
            this.menu = res;
        });
      }

      toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
      }
}
